//Please add the language resource
const diamondReportForm = {
  customerCode:'CustomerCode',
  packer: 'Packer',
  fileName:'FileName',
  statusName: 'StatusName',
  status: 'Status',
  remark: 'Remark',
  createTime: 'CreateTime',
  creator: 'Creator',
  result: 'Result',
};
export default diamondReportForm



// WEBPACK FOOTER //
// ./src/page/report/diamondReportForm/lang/diamondReportForm.en.js